import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { handleGetRequest } from "../../services/GetTemplate";
import { handlePostRequest } from "../../services/PostTemplate";
import { handlePutRequest } from "../../services/PutTemplate";
import { SetEditFlagAction, SetBranchAuthDetailsFormToNullAction } from "../../redux/actions/branchAction";
// import { SetEditFlagAction, SetAuthMatrixFurtherDetailsToNullAction, GetCompanyAccountAuthorizationAction } from "../../../redux/actions/companyAction";

function AddEditAuthMatrix({ handleAddEditAuthMatrix }) {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [productOptions, setproductOptions] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        handleGetRequest("zbizgateway/lov/lovProduct").then((res) => {
            setproductOptions(res?.data);
        });
    }, []); // eslint-disable-line

    const editFlag__Store = useSelector((state) => state.branchSlice?.editFlag);
    const formData__Store = useSelector((state) => state.branchSlice?.authBranchDetailsForm);

    useEffect(() => {
        if (editFlag__Store) {
            fillBranchAuthForm();
        }
    }, [editFlag__Store, formData__Store]); // eslint-disable-line

    const fillBranchAuthForm = () => {
        const productId = { code: formData__Store?.tblProduct?.masterProductCode, description: formData__Store?.tblProduct?.masterProductName, id: formData__Store?.tblProduct?.productId?.toString(), longText: null, shortText: null };
        formik.setFieldValue("toAmount", formData__Store?.toAmount.toString());
        formik.setFieldValue("fromAmount", formData__Store?.fromAmount.toString());
        formik.setFieldValue("isSequential", formData__Store?.isSequential);
        formik.setFieldValue("productId", productId);
    };

    const formik = useFormik({
        initialValues: {
            productId: "",
            isSequential: "N",
            fromAmount: "",
            toAmount: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.productId) {
                errors.productId = "This field is required.";
            }
            if (!data.fromAmount) {
                errors.fromAmount = "This field is required.";
            }
            if (!data.toAmount) {
                errors.toAmount = "This field is required.";
            }

            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            data["productId"] = data?.productId?.id;

            if (editFlag__Store) {
                data["authMatrixHeadId"] = formData__Store?.authMatrixHeadId;
                await handlePutRequest(data, "zbizgateway/nonFin/updateCompanyAuthMatrix");
                dispatch(SetEditFlagAction(false));
                dispatch(SetBranchAuthDetailsFormToNullAction());
                // dispatch(GetCompanyAccountAuthorizationAction("zbiz/nonFin/getCompanyAuthMatrix/" + companyId));
            } else {
                data["productId"] = parseInt(data?.productId);
                data["fromAmount"] = parseInt(data?.fromAmount);
                data["toAmount"] = parseInt(data?.toAmount);

                const res = await handlePostRequest(data, "zbizgateway/nonFin/saveBranchAuthMatrix");
                handleAddEditAuthMatrix(res);
            }

            setloading(false);
            setloadingIcon("pi pi-save");

            formik.resetForm();
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const handleCancel = (e) => {
        e.preventDefault();
        formik.resetForm();
        dispatch(SetEditFlagAction(false));
        dispatch(SetBranchAuthDetailsFormToNullAction());
    };

    return (
        <div className="card Card__Round">
            <div className="Form__Header">
                <h1>Branch Authorization </h1>
            </div>
            <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col-12 p-md-3">
                        <div className="p-field">
                            <label htmlFor="productId" className={classNames({ "p-error": isFormFieldValid("productId") }, "Label__Text")}>
                                Product<span className="Label__Required">*</span>
                            </label>
                            <Dropdown
                                id="productId"
                                placeholder="Enter Product"
                                options={productOptions}
                                optionLabel="description"
                                name="productId"
                                value={formik.values.productId}
                                onChange={formik.handleChange}
                                className={classNames({ "p-invalid": isFormFieldValid("productId") }, "Dropdown__Round")}
                            />
                            {getFormErrorMessage("productId")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-3">
                        <div className="p-field">
                            <label htmlFor="fromAmount" className={classNames({ "p-error": isFormFieldValid("fromAmount") }, "Label__Text")}>
                                From Amount<span className="Label__Required">*</span>
                            </label>
                            <InputText id="fromAmount" placeholder="Enter Amount" name="fromAmount" value={formik.values.fromAmount} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("fromAmount") }, "Input__Round")} />

                            {getFormErrorMessage("fromAmount")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-3">
                        <div className="p-field">
                            <label htmlFor="toAmount" className={classNames({ "p-error": isFormFieldValid("toAmount") }, "Label__Text")}>
                                To Amount<span className="Label__Required">*</span>
                            </label>
                            <InputText id="toAmount" placeholder="Enter Amount" name="toAmount" value={formik.values.toAmount} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("toAmount") }, "Input__Round")} />

                            {getFormErrorMessage("toAmount")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-3">
                        <label htmlFor="isSequential" className="Label__Text">
                            Sequential
                        </label>
                        <div className="Radio__Btn">
                            <div className="p-field-radiobutton">
                                <RadioButton inputId="isSequential" name="isSequential" value={"N"} onChange={formik.handleChange} checked={formik.values.isSequential === "N"} />
                                <label htmlFor="isSequential">No</label>
                            </div>
                            <div className="p-field-radiobutton">
                                <RadioButton inputId="isSequential" name="isSequential" value={"Y"} onChange={formik.handleChange} checked={formik.values.isSequential === "Y"} />
                                <label htmlFor="isSequential">Yes</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="Down__Btn">
                    <Button label="Cancel" onClick={(e) => handleCancel(e)} className="Btn__Transparent" />
                    <Button disabled={loading} icon={loadingIcon || ""} iconPos="right" label={editFlag__Store ? "Edit" : "Add"} className="Btn__Dark" />
                </div>
            </form>
        </div>
    );
}

export default AddEditAuthMatrix;
